import { render } from "./UserClubs.vue?vue&type=template&id=4b5cd32d"
import script from "./UserClubs.vue?vue&type=script&lang=js"
export * from "./UserClubs.vue?vue&type=script&lang=js"

import "./UserClubs.vue?vue&type=style&index=0&id=4b5cd32d&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__